import { render, staticRenderFns } from "./ByelawsCharkilla.vue?vue&type=template&id=3609ce09&scoped=true&"
import script from "./ByelawsCharkilla.vue?vue&type=script&lang=js&"
export * from "./ByelawsCharkilla.vue?vue&type=script&lang=js&"
import style0 from "./ByelawsCharkilla.vue?vue&type=style&index=0&id=3609ce09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3609ce09",
  null
  
)

export default component.exports